export default __webpack_public_path__ + "static/case-1-hero-71596f922b88e85f44e0fe3169d426af.png";